import InfoGraphic from '@/components/InfoGraphic/InfoGraphic'
import { WidgetInfographicProps } from '@/types/cms'

const InfoGraphicInline = ({ item }: { item: WidgetInfographicProps }) => {
  return (
    <>
      {item.items?.map((graphic) => (
        <InfoGraphic key={graphic.id} infographic={graphic} />
      ))}
    </>
  )
}

export default InfoGraphicInline
